<template>

    <div class="modal-container">

        <div class="modal-dialog-wrapper p-0" ref="modalDialogWrapper">
            <slot></slot>
        </div>


    </div>

</template>

<script>
    export default {

        props: {
            resetOnUpdate: {
                default: false
            },
        },

        updated() {
            // scroll to top on modals
            if(this.resetOnUpdate) {
                this.$refs.modalDialogWrapper.scrollTo(0, 0)
            }
        },

    }
</script>

<style>
    .modal-container {
        z-index: 1050 !important;
        position: fixed;
        background: white;
        top: 3rem;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        max-width: 576px;
        margin-left: auto;
        margin-right: auto;
    }

    .modal-container.modal-container--short {
        top: auto;
    }

    .modal-dialog-wrapper {
        z-index: 1050 !important;
        position: relative;
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        background: white;
    }
</style>
